import React from "react";
import { Link } from "react-router-dom";
import { Plus } from "lucide-react";
import { useCart } from "../context/CartContext";

export const ProductCard = ({ product, index = 0 }) => {
  const { addItem } = useCart();

  return (
    <div
      data-testid={`product-card-${product.id}`}
      className="group flex flex-col bg-ink-800 border border-ink-600 hover:border-brand transition-all duration-300 animate-fade-up"
      style={{ animationDelay: `${index * 60}ms` }}
    >
      <Link to={`/product/${product.id}`} className="relative block overflow-hidden aspect-[4/3]">
        <img
          src={product.image_url}
          alt={product.name}
          className="w-full h-full object-cover grayscale-[10%] group-hover:grayscale-0 group-hover:scale-105 transition-all duration-500"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-ink-900/80 via-transparent to-transparent" />
        <div className="absolute top-3 left-3 font-display text-xs tracking-[0.25em] text-brand bg-ink-900/70 px-2 py-1 border border-brand/40">
          {product.category.toUpperCase()}
        </div>
      </Link>

      <div className="flex flex-col flex-1 p-5">
        <Link to={`/product/${product.id}`}>
          <h3 className="font-display text-2xl text-cream group-hover:text-brand transition-colors leading-none">
            {product.name}
          </h3>
        </Link>
        <p className="text-[#A19D94] text-sm mt-2 line-clamp-2 flex-1">{product.description}</p>

        <div className="flex items-end justify-between mt-5 pt-4 border-t border-ink-600">
          <div>
            <div className="font-display text-3xl text-cream leading-none">
              ${product.price.toFixed(2)}
            </div>
            <div className="text-xs text-[#A19D94] mt-1 tracking-wider">{product.unit}</div>
          </div>
          <button
            data-testid={`add-to-cart-btn-${product.id}`}
            onClick={() => addItem(product, 1)}
            className="flex items-center gap-2 px-4 h-11 bg-brand hover:bg-brand-hover text-ink-900 font-display text-lg tracking-wide transition-all duration-200 teal-glow-hover"
          >
            <Plus size={16} strokeWidth={3} />
            ADD
          </button>
        </div>
      </div>
    </div>
  );
};
